<template>
  <div class="footer-box">
    <div class="footer-container">
      <!--            <el-row :gutter="10">-->
      <!--                <el-col :span="17" class="footer-font">-->
      <!--&lt;!&ndash;                    <img src="../image/logo-w.svg" class="footer-logo">&ndash;&gt;-->
      <!--                    <p> {{ $t('footer.t1') }}</p>-->
      <!--                    <p>{{ $t('footer.t2') }}</p>-->
      <!--                </el-col>-->
      <!--                <el-col :span="2">-->
      <!--                    <p class="curser"><span>{{ $t('footer.t3') }}</span></p>-->
      <!--                    <p class="curser" @click="goto({path: '/consultation',name: 'transport_consultation'})"><span>{{ $t('footer.t4') }}</span></p>-->
      <!--                    <p class="curser"><span>{{ $t('footer.t5') }}</span></p>-->
      <!--                </el-col>-->
      <!--                <el-col :span="2">-->
      <!--                    <p class="curser"><span>{{ $t('footer.t6') }}</span></p>-->
      <!--                    <p class="curser"><span>{{ $t('footer.t7') }}</span></p>-->
      <!--                    <p class="curser"><span>{{ $t('footer.t8') }}</span></p>-->
      <!--                </el-col>-->
      <!--                <el-col :span="3">-->
      <!--&lt;!&ndash;                    <img src="../image/App.svg" class="foot-img" style="width: 107px;height: 107px">&ndash;&gt;-->
      <!--&lt;!&ndash;                    <P>老中铁路货运APP</P>&ndash;&gt;-->
      <!--                </el-col>-->
      <!--            </el-row>-->

      <div class="footer-font">
        <!--                    <img src="../image/logo-w.svg" class="footer-logo">-->
        <!-- <p> {{ $t('footer.t1') }}</p>
        <p>{{ $t('footer.t2') }}</p> -->
        <p>Copyright @ 2024-2025 China Academy of Railway Sciences Corporation Limited.All rights reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    let lang = localStorage.getItem('lang')
    this.$i18n.locale = lang;
    this.$store.dispatch("app/setLanguage", lang);
  }
}

</script>

<style lang="scss">
.footer-box {
  .footer-container {
    //width: $containerWidth;
    max-width: 1920px;
    height: 140px;
    margin: 0 auto;
    background-image: linear-gradient(0deg, #403942 0%, #312835 100%);
    display: flex;
    color: #FFFFFF;
    align-items: center;
    justify-content: center;
    p {
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      //opacity: 0.5;
      &:first-child{
        margin-bottom: 24px;
      }
    }

    .curser {
      cursor: pointer;
    }

    .footer-font {
      opacity: 0.5;
      font-size: $font-small;
      display: flex;
      flex-direction: column;
      align-items: center;
      .footer-logo {
        width: 160px;
        margin: 2px 0 40px 0;
        vertical-align: top;
      }

      p:first-of-type {
        margin: 0px 0 10px 0;
      }
    }

    .foot-img {
      display: block;
    }

  }
}
</style>
